// extracted by mini-css-extract-plugin
export default {"container":"StarterDashboard_container__qZPJU Dashboard_container__OjzSP","scoreCards":"StarterDashboard_scoreCards__POEH2 Dashboard_scoreCards__5nZBn"};